<template>
    <div class="message-content">
        <div class="ballon-message">
            <message-balon 
                typeBalon="message"
                textBalon=' "Você foi muito bom no game, eu gostei muito da sua participação no processo seletivo." '
                nameBalon="Vitor Vicente Correia"
                :color="color"></message-balon>
        </div>
        <div class="ballon-right">
            <message-balon
                typeBalon="right"></message-balon>
        </div>
        <message-person :color="color.name"></message-person>
    </div>
</template>
<script>
import MessageBalon from './MessageBalon.vue'
import MessagePerson from './MessagePerson.vue'
export default {
    components : {
        MessageBalon,
        MessagePerson
    },
    data(){
        return{
            color : {
                color: '#f97218',
                name : 'orange'
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .message-content{
        width: 100%;
        height: 100%;
        background-color : #cffbfa;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .ballon-message{
            margin-bottom: 40%;
        }

        .ballon-right{
            position: absolute;
            bottom: 15%;
            left: 30%;
        }
    }

    @media only screen and (min-width: 700px){
        .message-content{
            .ballon-message{
                margin-bottom: 180px;
                margin-left: 20px;
            }
            .ballon-right{
                left: 45%;
            }
        } 
    }
</style>
